import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import styled from "@emotion/styled";
import CustomizedSearchBar from "../components/Inputs/SearchBar";
import TableTemplate from "../components/Category/TableTemplate";
import { getAdmin } from "../helper/API/permission";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { connect } from "react-redux";
import * as categoryAction from "../redux/categoryList/action";
import SearchInput from "../components/SearchInput";
import { getTaskCategoryColor } from "../helper/API/category";
import AddCategoryModal from "../components/Category/AddCategoryModal";

const Img = styled("img")({
	// margin: 'auto',
	display: "block",
	maxWidth: "100%",
	maxHeight: "100%",
});

const Category = ({ categoryListFromRedux, categoryListData, processing }) => {
	const [tableRows, setTableRows] = React.useState();
	const [loading, setLoading] = React.useState(false);
	const [refresh, setRefresh] = React.useState(1);
	const [searchVal, setSearchVal] = React.useState("");
	const [show, setShow] = React.useState(false);
	const [categoryColor, setCategoryColor] = React.useState([]);

	const navigate = useNavigate();

	React.useEffect(() => {
		categoryListData();
	}, []);
	React.useEffect(() => {
		getTaskCategoryColor().then((res) => {
			// console.log("res color", res);
			if (res.success) {
				setCategoryColor(res.data);
			}
		});
	}, []);

	React.useEffect(() => {
		setTableRows(categoryListFromRedux);
	}, [categoryListFromRedux]);

	// console.log("tableRows", categoryListFromRedux);
	const onAddCategoryShow = () => {
		setShow(true);
	};

	// SEARCH IN TABLE
	const onSearchAdmin = () => {
		setSearchVal("");
		setTableRows(categoryListFromRedux);
	};

	const onChangeSearch = (event) => {
		setSearchVal(event.target.value);
		if (event.target.value) {
			var updateState = tableRows.filter(({ label }) =>
				label.toLowerCase().includes(event.target.value.toLowerCase())
			);
			setTableRows(updateState);
			// console.log("obj if 1", updateState);
			updateState = [];
		} else if (event.target.value == "") {
			setTableRows(categoryListFromRedux);
			// console.lo/g("obj if 2");
		} else {
			setTableRows([]);
			// console.log("obj if 3");
		}
	};

	return (
		<Box sx={{ flexGrow: 1, background: "#F8F5FA" }} px={8} py={4}>
			{/* <CustomizedSearchBar /> */}
			<SearchInput
				onChange={onChangeSearch}
				searchVal={searchVal}
				onClick={onSearchAdmin}
				placeholder='Administrador de pesquisa'
			/>

			<div style={{ display: "flex", justifyContent: "flex-end" }}>
				<Button
					variant='contained'
					sx={{ marginBottom: 3 }}
					onClick={onAddCategoryShow}>
					Adicionar categoria
				</Button>
			</div>
			{processing ? (
				<Loader />
			) : (
				<TableTemplate
					rows={tableRows}
					setRefresh={setRefresh}
					refresh={refresh}
					categoryColor={categoryColor}
				/>
			)}

			{show && (
				<AddCategoryModal
					categoryColor={categoryColor}
					open={show}
					onHide={() => setShow(false)}
					setRefresh={setRefresh}
					refresh={refresh}
				/>
			)}
		</Box>
	);
};

const mapDispatchToProp = (dispatch) => {
	return {
		categoryListData: () => dispatch(categoryAction.categoryList()),
	};
};
const mapStateToProp = (state) => {
	// console.log("state", state);
	return {
		categoryListFromRedux:
			state?.categoryListReducer?.categoryList?.getAllTask,
		processing: state?.categoryListReducer?.processing,
	};
};
export default connect(mapStateToProp, mapDispatchToProp)(Category);
